module.exports = __webpack_public_path__ + "static/media/TUNE_4510.69799313.jpg";